module.exports = __webpack_public_path__ + "static/event-2-2402af52aeb70ca8e1dc876829fa6e24.gif";